/**
 * Web drop-target shell — a real DOM `<div>`.
 *
 * react-native-web's `<View>` does not forward HTML drag handlers (`onDrop`, `onDragOver`, …) —
 * they are absent from `forwardedProps` and never reach the DOM. Legacy (`LiveHelpModal`,
 * `ImageUploadZone`) uses a raw `<div>` for the same reason. `createElement("div", …)` is the
 * RN-web-sanctioned escape hatch.
 */
import { createElement } from "react"

import { type DropTargetProps } from "./DropTarget"

type WebDragEvent = {
    preventDefault: () => void
    stopPropagation: () => void
    dataTransfer?: { files?: FileList | null }
}

export type { DropTargetProps }

export function DropTarget(props: DropTargetProps) {
    const { children, onDragEnter, onDragOver, onDragLeave, onDrop } = props

    // Real DOM node — RN-web <View> strips drag handlers from forwarded props.
    return createElement(
        "div",
        {
            onDragEnter: onDragEnter as ((event: WebDragEvent) => void) | undefined,
            onDragOver: onDragOver as ((event: WebDragEvent) => void) | undefined,
            onDragLeave: onDragLeave as ((event: WebDragEvent) => void) | undefined,
            onDrop: onDrop as ((event: WebDragEvent) => void) | undefined,
            style: {
                width: "100%",
                display: "flex",
                flexDirection: "column",
            },
        },
        children
    )
}
